import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../../shared/components/UIElements/Footer';
import './HomePage.css';

const HomePage = () => {
  return (
    <React.Fragment>
      <div className="home-container">

        {/* Hero Section */}
        <section className="hero">
          <h1>Secure File Storage & Sharing</h1>
          <p>
            Store your files securely in your personal space.
            Share selected files using a one-time password (OTP) —
            safe, controlled, and simple.
          </p>

          <div className="hero-buttons">
            {/*<button to="/auth" className="primary-btn">Sign Up/Login</button>*/}
            <Link to="/auth" className="primary-btn">Sign Up / Login </Link>
            {/*<button className="secondary-btn">Login</button>*/}
          </div>
        </section>

        {/* How It Works */}
        <section className="how-it-works">
          <h2>How It Works</h2>

          <div className="steps">
            <div className="step">
              <h3>1. Sign Up & Login</h3>
              <p>
                Create an account and log in to access your private file space.
              </p>
            </div>

            <div className="step">
              <h3>2. Upload & Manage Files</h3>
              <p>
                Upload files and keep them private. Move files to the shared
                folder only when you want to share.
              </p>
            </div>

            <div className="step">
              <h3>3. Generate OTP</h3>
              <p>
                Generate a one-time password from your account and share it
                securely.
              </p>
            </div>

            <div className="step">
              <h3>4. External Access</h3>
              <p>
                Anyone can enter the OTP on the public access page to view, download
                shared files — no account required.
              </p>
            </div>
          </div>
        </section>

        {/* Public OTP Access */}
        <section className="public-access">
          <h2>Have an OTP?</h2>
          <p>
            If someone shared an OTP with you, use it here to access shared files.
          </p>
          {/*<button className="primary-btn">Access Files with OTP</button>*/}
          <Link to="/entercode" className="primary-btn">Access Files with OTP</Link>
        </section>

      </div>

      {/* Footer */}
      <Footer />
    </React.Fragment>
  );
};

export default HomePage;
